<template>
	<div class="content">
		<div class="content_head">
			<select v-model="seriesID" @change="pageIndex=1;getbooksSeriesList()">
				<option v-for="(i,index) in booksSeries" :value="i.seriesID">{{i.seriesName}}</option>
			</select>
			&nbsp;
			<button type="button" class="button add" @click="addSeries">+新增</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>类别名称</th>
						<th>类别描述</th>
						<th>类别归属</th>
						<th>书籍数量</th>
						<th>类别图标</th>
						<th>删除</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in booksSeriesList">
						<td class="center">
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							{{i.booksSeriesListName}}
						</td>
						<td style="white-space: nowrap;;overflow: hidden;text-overflow: ellipsis;max-width:10rem;">
							{{i.booksSeriesListDesc}}
						</td>
						<td>
							{{i.seriesName}}

						</td>
						<td :class="{'red':i.count==0}">
							{{i.count+'本'}}
						</td>
						<td>
							<img v-if="i.logo!='' && i.logo!=null" style="height:4rem;width: 4rem;"
								:src="$store.state.logoUrl +'/' +i.logo" />
						</td>
						<td>
							<button type="button" class="button" @click='updateSeries(i)'>
								修改
							</button>
							<button type="button" class="button" @click='removebooksSeries(i)'>
								删除
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>
			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="15">15/页</option>
				<option value="20">20/页</option>
			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>

		<div class="edit" v-show="Edit!=''">
			<div>
				<p>
					<label>
						<span class="red"></span>标签名称:
						<input v-model="booksSeriesListName" type="text" placeholder="请输入标签名称" />
					</label>
				</p>
				<p>
					<label>
						<span class="red"></span>标签描述:
						<textarea v-model="booksSeriesListDesc" type="text" placeholder="请输入标签描述">

					 </textarea>

					</label>
				</p>
				<p>
					<label>
						<span class="red"></span>图片类型:
						<select v-model="seriesID" @change="pageIndex=1;getbooksSeriesList()">
							<option v-for="(i,index) in booksSeries" :value="i.seriesID">{{i.seriesName}}</option>
						</select>
					</label>
				</p>
				<p>
					<label>
						标签图片:
						<button type="button" class="button" @click="selectFile">点击选择图片</button>
						<input type="file" style="display:none;" ref='camear' />
						<span class="err">{{checkFile}}</span>
					</label>
				</p>
				<p v-if="fileName!=''" style="text-align: center;">
					<img :src="img" ref='preview' style="width: 10rem;height: auto;" />
				</p>
				<p>
					<button class="button" :class="{'disabled':checkFile.length>0}" :disabled="checkFile.length>0"
						@click="saveData">{{Edit=='add'?'新增':'修改'}}</button>
					<button class="button" @click="Edit=''">取消</button>
				</p>
			</div>
		</div>

	</div>
</template>

<script>
	import j from './booksSeries.js'
	export default j
</script>

<style>
</style>
